import React from 'react';
import { SkeletonGridItems, SkeletonHeader, SmartGridRow } from '@app/ui';
import DynamicRowHeader from './DynamicRowHeader';

interface DynamicProductRowSkeletonProps {
  headerToMaintain?: {
    title: string;
    seeAllCTA: {
      title: string;
      url: string;
      urlType: string;
    };
    helpMessage: string;
  };
}

const DynamicProductRowSkeleton = ({
  headerToMaintain,
}: DynamicProductRowSkeletonProps) => (
  <>
    {headerToMaintain ? (
      <DynamicRowHeader
        header={headerToMaintain?.title}
        seeAllCTA={headerToMaintain?.seeAllCTA}
        helpMessage={headerToMaintain?.helpMessage}
      />
    ) : (
      <SkeletonHeader />
    )}
    <SmartGridRow columns={6}>
      <SkeletonGridItems items={6} />
    </SmartGridRow>
  </>
);

export default DynamicProductRowSkeleton;
